.text {
  max-width: 100%;
  overflow: hidden;
  color: inherit;
  font-size: inherit;
  line-height: inherit;
  font-family: var(--font-sans);
  text-overflow: ellipsis;
  text-transform: inherit;
  letter-spacing: inherit;
  white-space: inherit;
  font-variant-numeric: inherit;
  font-synthesis: none;
}

.serif {
  font-family: var(--font-serif);
}

/* VARIANTS */

.label {
  display: block;
  margin-bottom: 0.4375rem;
  color: var(--neutral-500);
  font-weight: 500;
  font-size: 0.75rem;
  letter-spacing: 0.05rem;

  @media (min-width: 400px) {
    margin-bottom: 0.625rem;
    font-size: 0.8125rem;
  }
}

.caption {
  font-weight: 400;

  &.small {
    font-size: 0.875rem;
  }

  &.regular {
    font-size: 0.875rem;

    @media (min-width: 400px) {
      font-size: 1rem;
    }
  }

  &.large {
    font-size: 1rem;
  }
}

.control,
.paragraph {
  &.small {
    font-size: 1rem;
  }

  &.regular {
    font-size: 1rem;

    @media (min-width: 400px) {
      font-size: 1.125rem;
    }
  }

  &.large {
    font-size: 1.125rem;
  }
}

.control {
  font-weight: 500;
}

.paragraph {
  font-weight: 400;
}

.heading-6 {
  font-size: 1.125rem;

  @media (min-width: 400px) {
    font-size: 1.25rem;
  }
}

.heading-5 {
  font-size: 1.25rem;

  @media (min-width: 400px) {
    font-size: 1.5rem;
  }
}

.heading-4 {
  font-size: 1.5rem;

  @media (min-width: 400px) {
    font-size: 1.75rem;
  }
}

.heading-3 {
  font-size: 1.75rem;

  @media (min-width: 400px) {
    font-size: 1.875rem;
  }
}

.heading-2 {
  font-size: 1.875rem;

  @media (min-width: 400px) {
    font-size: 2rem;
  }
}

.heading-1 {
  font-size: 2rem;

  @media (min-width: 400px) {
    font-size: 2.25rem;
  }
}

.super {
  font-size: 2.5rem;
  font-weight: 600;
}

/* WEIGHTS */

.w100 {
  font-weight: 100;
}

.w200 {
  font-weight: 200;
}

.w300 {
  font-weight: 300;
}

.w400 {
  font-weight: 400;
}

.w500 {
  font-weight: 500;
}

.w600 {
  font-weight: 600;
}

.w700 {
  font-weight: 700;
}

.w800 {
  font-weight: 800;
}

.w900 {
  font-weight: 900;
}

.winherit {
  font-weight: inherit;
}

/* COLORS */

.neutral {
  color: var(--neutral);
}

.neutral-50 {
  color: var(--neutral-50);
}

.neutral-100 {
  color: var(--neutral-100);
}

.neutral-200 {
  color: var(--neutral-200);
}

.neutral-500 {
  color: var(--neutral-500);
}

.neutral-600 {
  color: var(--neutral-600);
}

.neutral-800 {
  color: var(--neutral-800);
}

.primary-50 {
  color: var(--primary-50);
}

.primary-200 {
  color: var(--primary-200);
}

.primary-500 {
  color: var(--primary-500);
}

.primary-600 {
  color: var(--primary-600);
}

.primary-700 {
  color: var(--primary-700);
}

.danger {
  color: var(--danger);
}

.warning {
  color: var(--warning);
}
